import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Select } from 'antd';



import CRUDE_TipiSsilokNaFaili from '../../../objects/TipiSsilokNaFaili/crude'
import REDUX_TipiSsilokNaFaili from '../../../objects/TipiSsilokNaFaili/reducer'

import UploadItem from '../../components/UploadItem'

const { Option } = Select;


export default function MeropriyatieFileUpload(props) {
    const { auth, object, context } = props;
    const dispatch = useDispatch();

    const tipSsilki = useSelector(REDUX_TipiSsilokNaFaili.selector.array);
    useEffect(() => {
        CRUDE_TipiSsilokNaFaili.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_TipiSsilokNaFaili.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
    }, []);
    const tipSsilkiOptions = tipSsilki.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    return (
        <>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    meropriyatieID: context.ID,
                }}
            >
                <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"meropriyatieID"}
                    label={"Мероприятие"}
                >
                    <Input disabled />
                </Form.Item>
                <Form.Item label={"Название"}
                    name="nazvanie"
                    rules={[
                        { required: true, message: 'Пожалуйста, введите название!' }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Тип ссылки на файл"
                    name="tipSsilkiID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите тип ссылки!' }]}
                >
                    <Select showSearch>
                        {tipSsilkiOptions}
                    </Select>
                </Form.Item>
                <Form.Item 
                    name="file"
                    rules={[{ required: true, message: 'Пожалуйста, укажите файл!' }]}
                >
                    <UploadItem />
                </Form.Item>
            </Form>
        </>
    );
}
